console.log("NEWSLETTER POPUP JS EXECUTED");
window.__popupLoaded = true;

(function () {
  class PopupController {
    constructor(popup) {
      this.popup = popup;
      this.delay = parseInt(popup.dataset.delaySeconds || "5");
      this.dismissDays = parseInt(popup.dataset.dismissForDays || "30");
      this.testMode = popup.dataset.testMode === "true";
      this.id = popup.dataset.sectionId || "popup";

      this.cookieKey = `popup_dismissed_${this.id}`;

      this.closeButtons = popup.querySelectorAll("[data-modal-close]");
      this.overlay = popup.querySelector(".modal__overlay");

      this.bindEvents();
      this.init();
    }

    bindEvents() {
      // Close buttons (X + overlay)
      this.closeButtons.forEach((btn) => {
        btn.addEventListener("click", () => this.close());
      });

      // ESC key closes popup
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.close();
      });
    }

    init() {
      // If NOT test mode and popup was dismissed, do nothing
      if (!this.testMode && this.isDismissed()) {
        return;
      }

      // Wait the delay, then show popup
      setTimeout(() => this.open(), this.delay * 1000);
    }

    open() {
      console.log("Opening popup…");

      this.popup.style.display = "flex";
      requestAnimationFrame(() => {
        this.popup.style.opacity = "1";
        this.popup.style.pointerEvents = "auto";
        this.popup.classList.add("modal--active");
      });
    }

    close() {
      console.log("Closing popup…");

      this.popup.classList.remove("modal--active");
      this.popup.style.opacity = "0";
      this.popup.style.pointerEvents = "none";

      // Fully hide after fade
      setTimeout(() => {
        this.popup.style.display = "none";
      }, 200);

      this.setDismissed();
    }

    isDismissed() {
      return document.cookie.includes(`${this.cookieKey}=true`);
    }

    setDismissed() {
      const date = new Date();
      date.setTime(
        date.getTime() + this.dismissDays * 24 * 60 * 60 * 1000
      );
      document.cookie = `${this.cookieKey}=true; expires=${date.toUTCString()}; path=/`;
    }
  }

  // Auto-initialize all newsletter popup sections
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll('[data-section-type="newsletter-popup"]')
      .forEach((popup) => new PopupController(popup));
  });
})();
